export const DEFAULT_TIME_BRACKETS = [900, 600, 300, 120, 60] 
